import { useMemo } from 'react';
import { channelCategoryListQuery } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { useGqlQuery } from '@/shared/hooks/useGqlQuery';

import { ALL_CHANNELS_ID } from '../constants';

import { useI18n } from './useI18n';

export function useChannelCategoryList() {
    const i18n = useI18n();

    const { data } = useGqlQuery(channelCategoryListQuery, {});

    return useMemo(() => {
        const allChannelsCategory = {
            title: i18n('channels_all_channels_category'),
            id: ALL_CHANNELS_ID,
            description: '',
        };

        return [
            allChannelsCategory,
            ...(data?.categories?.map(({ id, title, description }) => ({
                id: String(id),
                title,
                description: description ?? '',
            })) || []),
        ];
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);
}
